import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

export const classes: Record<string, SystemStyleObject<Theme>> = {
  overlay: {
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  videoWrapper: {
    minHeight: "480px",
    height: "100%",
    position: "relative",
    textAlign: "center",
    overflow: "hidden",
    borderRadius: "10px",
    transition:
      "margin-right 225ms cubic-bezier(0, 0, 0.2, 1) 0ms, opacity 500ms ease-in",

    "video::-webkit-media-controls": {
      display: "none !important",
    },

    "video::-webkit-media-controls-enclosure": {
      display: "none !important",
    },

    backgroundColor: "background.default",
  },

  drawerButton: {
    zIndex: 4,
    background: ({ palette }) => palette.dark.secondary,
    color: "text.primary",
    "&:hover": {
      color: ({ palette }) => palette.dark.tertiary,
    },
  },

  additionalActions: {
    display: "flex",
    position: "absolute",
    gap: ({ spacing }) => spacing(1),
    right: ({ spacing }) => spacing(2),
    top: ({ spacing }) => spacing(2),
  },

  watermark: {
    position: "absolute",
    top: ({ spacing }) => spacing(1),
    right: ({ spacing }) => spacing(1),
  },
};
